import { render, staticRenderFns } from "./caching.vue?vue&type=template&id=56557027&"
import script from "./caching.vue?vue&type=script&lang=js&"
export * from "./caching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports